import {Component, Inject, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl,} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatOption} from '@angular/material/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatSelect} from '@angular/material/select';
import {ROLES, User} from '@app/shared/user.service';

@Component({
    selector: 'frog-user-role-dialog',
    templateUrl: './user-role-dialog.component.html',
    styleUrls: ['./user-role-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        ReactiveFormsModule,
        FormsModule,
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class UserRoleDialogComponent implements OnInit {
    public roleControl: UntypedFormControl;
    public roles = ROLES;

    constructor(
        private formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<UserRoleDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: User,
    ) {
        const roleId = this.data.getRole();
        this.roleControl = new UntypedFormControl(roleId);
    }

    ngOnInit(): void {}

    save() {
        this.dialogRef.close(this.roleControl.value);
    }
}
